import Swiper from 'swiper'

import openOfferLinkInNewWindow from '@/modules/customizations/openOfferLinkInNewWindow'

const $ = require('jquery')

const ajaxLoader = require('@/modules/ajaxLoader')
const { URL_API } = require('@/modules/api')
const { Loader, isMobileView } = require('@/modules/globals')
const Overlay = require('@/modules/overlay')
const Tooltips = require('@/modules/tooltips')

export default class SimilarOffers {
  constructor (root) {
    this.root = root
    this.loadButton = document.querySelector('.btn-load--load-similar-offers')
    this.pageCounter = 1
    this.slider = null
  }

  similarOffersConfig () {
    const _ = this
    const placeholder = isMobileView() ? $(this.root.querySelector('.swiper-wrapper')) : $(this.root)

    return { 
      devTest: false, 
      url: _.loadButton.getAttribute('href'), 
      method: 'GET', 
      templateName: 'OffersList', 
      elemCaller: _.loadButton,
      placeholder,
      type: 'offersList', 
      beforeSendRequest () { 
        Overlay.addTo($('.offer-list'), 'grey') 
        $('.offer-list > .container > .col-xs-12').append(Loader('small', 'blue', true)) 
      }, 
      afterSuccess () { 
        const newUrl = function() { 
          let noQueryString = null 
          if (window.location.search != '') { 
            noQueryString = '&' 
          } else { 
            noQueryString = '?' 
          } 
          const newHref = `${URL_API.LoadMoreSimilarOffers + window.location.search + noQueryString}pageFrom=${_.pageCounter}&hotel=${_.loadButton.getAttribute('data-hotel-slug')}` 
 
          return newHref 
        } 
 
        _.loadButton.setAttribute('href', newUrl()) 
 
        $('span.price__full').show()
        $('span.price__person').hide()
 
        if (!$('.custom-tooltip__data').exists()) { 
          Tooltips.loadDataTooltips() 
        } 
 
        Overlay.removeFrom($('.offer-list')) 
        $('.offer-list > .container > .col-xs-12') 
          .find('.loader-wrap') 
          .fadeOut(100) 
          .delay(100).remove() 
 
        openOfferLinkInNewWindow.init()

        if (isMobileView()) _.updateOfferSlider()
      }, 
    } 
  }

  initAjaxRequest (e) {
    e.preventDefault()
    e.stopPropagation()

    this.pageCounter++
    const config = this.similarOffersConfig()

    ajaxLoader.init(config)
  }

  createPlaceholderForSlider () {
    const div = document.createElement('div')
    div.classList.add('swiper-wrapper')
    return div
  }

  wrapNodesIntoPlaceholder () {
    const wrapper = this.createPlaceholderForSlider()
  
    Array.from(this.root.children).forEach(el => {
      el.classList.add('swiper-slide')
      wrapper.insertAdjacentElement('beforeend', el)
    })
  
    return this.root.insertAdjacentElement('afterbegin', wrapper)
  }

  updateOfferSlider () {
    this.root.querySelectorAll('.offer-list-item__wrapper').forEach(el => {
      if (!el.classList.contains('swiper-slide')) el.classList.add('swiper-slide')
    })
    
    this.slider.update()
  }

  mountOfferSlider () {
    this.slider = new Swiper(this.root, {
      loop: false,
      autoplay: true,
      slidesPerView: 1,
    })
  }

  setupOfferSlider () {
    return Promise.resolve()
      .then(() => this.wrapNodesIntoPlaceholder())
      .then(() => this.mountOfferSlider())
  }

  init () {
    if (isMobileView()) this.setupOfferSlider()
    if (this.loadButton) this.loadButton.addEventListener('click', e => this.initAjaxRequest(e))
  }
}


// WEBPACK FOOTER //
// ./src/components/SimilarOffers.js